class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    this.backdropClose = this.querySelector('[data-backdrop-overlay]');
    this.backdropClose.addEventListener('click', this.onBodyClick);
  }
  handleBodyClick(evt) {
    const target = evt.target;
    if (target.closest('cart-drawer')) {
      this.close();
    }
  }
  handleCursorMove() {
    const cursorWrapper = this.querySelector('[data-cursor-hover]');

    gsap.set(cursorWrapper, { xPercent: 0, yPercent: 0 });

    const xTo = gsap.quickTo(cursorWrapper, 'x', { duration: 0.1, ease: 'power3' });
    const yTo = gsap.quickTo(cursorWrapper, 'y', { duration: 0.1, ease: 'power3' });

    this.backdropClose.addEventListener('mousemove', (e) => {
      gsap.to(cursorWrapper, { opacity: 1, scale: 1, duration: 0.1 });
      xTo(e.clientX);
      yTo(e.clientY);
    });
    this.backdropClose.addEventListener('mouseleave', (e) => {
      gsap.to(cursorWrapper, { scale: 0, duration: 0.1 });
    });
    this.backdropClose.addEventListener('mouseenter', (e) => {
      gsap.to(cursorWrapper, { scale: 1, duration: 0.1 });
    });
  }

  open() {
    if (document.querySelector('quick-view-drawer')) {
      document.querySelector('quick-view-drawer').classList.remove('open');
      document.body.classList.remove('overflow-hidden');
      document.body.removeAttribute('data-lenis-prevent');
    }
    this.cart_drawer = document.querySelector('cart-notification');
    if (this.cart_drawer) {
      setTimeout(() => {
        this.cart_drawer.classList.add('open');
        document.body.classList.add('overflow-hidden');
      }, 200);
      document.body.setAttribute('data-lenis-prevent', 'true');
    }
    this.handleCursorMove();
  }
  close() {
    this.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
    document.body.removeAttribute('data-lenis-prevent');
  }
  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      const html = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector).innerHTML;
      elementToReplace.innerHTML = html;
    });
    setTimeout(() => {
      this.querySelector('[data-backdrop-overlay]').addEventListener('click', this.close.bind(this));
      this.open();
    });
    const countElement = document.querySelector('[cart-notification-items]');
    const count = countElement.getAttribute('data-items');
    const cartIcons = document.querySelectorAll('[data-cart-icon-bubble]');
    if (cartIcons.length > 0) {
      // Check if there are any cart icons
      cartIcons.forEach((cartIcon) => {
        if (cartIcon.classList.contains('is-empty-cart')) {
          // Check if the cart icon is marked as empty
          const hiddenSpan = document.createElement('span');
          hiddenSpan.className = 'visually-hidden';
          hiddenSpan.textContent = 'Cart';

          const countBubble = document.createElement('div');
          countBubble.className = 'cart-count-bubble';

          const countSpan = document.createElement('span');
          countSpan.setAttribute('aria-hidden', 'true');
          countSpan.setAttribute('data-total-cart-item', '');
          countSpan.textContent = count;

          cartIcon.appendChild(hiddenSpan);
          cartIcon.appendChild(countBubble);

          countBubble.appendChild(countSpan);

          // Remove the 'is-empty-cart' class to show the cart has items
          cartIcon.classList.remove('is-empty-cart');
        }
      });
    } else {
      document.querySelectorAll('[data-total-cart-item]').forEach((element) => {
        element.innerHTML = count;
      });
      if (count > 0) {
        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          bubble.classList.remove('hidden');
        });
      } else {
        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          bubble.classList.add('hidden');
        });
      }
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
